// extracted by mini-css-extract-plugin
export default {"root":"CheckBox_root__TNYbM","input":"CheckBox_input__+qUHf","ellipse":"CheckBox_ellipse__dNEMD","text":"CheckBox_text__3Qqd2"};